/*
 * Esprit Salopette — agrandissement d'images (détails produit, photos clients).
 * Tout élément portant data-es-lightbox-src (idéalement un <button>) ouvre l'image dans une <dialog> native :
 * fermeture par le bouton « Fermer », la touche Échap ou un clic sur le fond ; le focus revient sur le déclencheur.
 * Attributs facultatifs : data-es-lightbox-alt, data-es-lightbox-caption,
 * data-es-lightbox-group (les éléments du même groupe se parcourent avec ← → et les flèches, compteur « 1/3 »).
 */
(() => {
  if (window.EsLightbox) return;

  let dialog;
  let image;
  let caption;
  let counter;
  let prevButton;
  let nextButton;
  let trigger;
  let group = [];
  let position = 0;

  const css = `
    .es-lb { width: 100vw; max-width: 100vw; height: 100dvh; max-height: 100dvh; margin: 0; padding: 0; border: 0; background: rgb(12 12 12 / .95); color: #fff; }
    .es-lb::backdrop { background: rgb(0 0 0 / .6); }
    .es-lb__figure { margin: 0; height: 100%; display: grid; grid-template-rows: minmax(0, 1fr) auto; align-items: center; justify-items: center; gap: 10px; padding: 64px 12px 20px; box-sizing: border-box; }
    .es-lb__img { max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 8px; }
    .es-lb__caption { font-size: 15px; line-height: 1.4; text-align: center; max-width: 640px; color: #f3efe6; }
    .es-lb__close, .es-lb__nav { position: absolute; border: 0; border-radius: 50%; background: #fff; color: #111; cursor: pointer; display: grid; place-items: center; }
    .es-lb__close { top: 12px; right: 12px; width: 48px; height: 48px; font-size: 28px; line-height: 1; }
    .es-lb__nav { top: 50%; width: 48px; height: 48px; transform: translateY(-50%); }
    .es-lb__nav svg { width: 20px; height: 20px; fill: none; stroke: currentColor; stroke-width: 2.4; }
    .es-lb__nav--prev { left: 12px; }
    .es-lb__nav--next { right: 12px; }
    .es-lb__nav:hover { background: var(--es-primary, #d4af37); }
    .es-lb__nav[hidden] { display: none; }
    .es-lb__counter { position: absolute; top: 22px; left: 50%; transform: translateX(-50%); margin: 0; padding: 4px 12px; border-radius: 999px; background: rgb(255 255 255 / .14); font-size: 14px; font-weight: 700; font-variant-numeric: tabular-nums; }
    .es-lb__close:focus-visible, .es-lb__nav:focus-visible { outline: 3px solid #d4af37; outline-offset: 3px; }
  `;

  function show(i) {
    position = (i + group.length) % group.length;
    const target = group[position];
    image.src = target.dataset.esLightboxSrc;
    image.alt = target.dataset.esLightboxAlt || '';
    caption.textContent = target.dataset.esLightboxCaption || '';
    caption.hidden = !caption.textContent;
    const many = group.length > 1;
    prevButton.hidden = !many;
    nextButton.hidden = !many;
    counter.hidden = !many;
    counter.textContent = `${position + 1}/${group.length}`;
  }

  function build() {
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    dialog = document.createElement('dialog');
    dialog.className = 'es-lb';
    dialog.setAttribute('aria-label', 'Photo agrandie');
    dialog.innerHTML = '<button type="button" class="es-lb__close" aria-label="Fermer la photo agrandie">×</button>'
      + '<p class="es-lb__counter" aria-live="polite" hidden></p>'
      + '<button type="button" class="es-lb__nav es-lb__nav--prev" aria-label="Photo précédente" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>'
      + '<button type="button" class="es-lb__nav es-lb__nav--next" aria-label="Photo suivante" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>'
      + '<figure class="es-lb__figure"><img class="es-lb__img" alt=""><figcaption class="es-lb__caption"></figcaption></figure>';
    document.body.appendChild(dialog);

    image = dialog.querySelector('.es-lb__img');
    caption = dialog.querySelector('.es-lb__caption');
    counter = dialog.querySelector('.es-lb__counter');
    prevButton = dialog.querySelector('.es-lb__nav--prev');
    nextButton = dialog.querySelector('.es-lb__nav--next');

    prevButton.addEventListener('click', () => show(position - 1));
    nextButton.addEventListener('click', () => show(position + 1));
    dialog.addEventListener('keydown', (event) => {
      if (group.length < 2) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(position - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(position + 1); }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('.es-lb__close') || event.target.classList.contains('es-lb__figure')) dialog.close();
    });
    dialog.addEventListener('close', () => {
      image.removeAttribute('src');
      if (trigger) trigger.focus({ preventScroll: true });
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-es-lightbox-src]');
    if (!target) return;
    event.preventDefault();
    if (!dialog) build();
    if (typeof dialog.showModal !== 'function') {
      window.open(target.dataset.esLightboxSrc, '_blank', 'noopener');
      return;
    }

    trigger = target;
    const name = target.dataset.esLightboxGroup;
    group = name ? Array.from(document.querySelectorAll(`[data-es-lightbox-group="${CSS.escape(name)}"]`)) : [target];
    show(Math.max(0, group.indexOf(target)));
    dialog.showModal();
    dialog.querySelector('.es-lb__close').focus();
  });

  window.EsLightbox = true;
})();
